module.exports = __webpack_public_path__ + "img/icon2@2x.2a04f197.png";